import { render } from "./NewTDASessions.vue?vue&type=template&id=c21bed5c"
import script from "./NewTDASessions.vue?vue&type=script&lang=js"
export * from "./NewTDASessions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__